
import MessageBox from "../MessageBox.vue";
import { User } from "../../../../../../domain/entities/entities";
import { defineComponent, PropType, Ref, ref } from "vue";
export default defineComponent({
  components: { MessageBox },
  name: "Layout6",
  props: {
    message: {
      required: true,
      type: String
    },
    animationIsReverse: {
      required: false,
      type: Boolean
    },
    user: {
      type: Object as PropType<User>,
      required: true
    }
  },
  setup({ user }, { emit }) {
    const isTransitionFinished = ref(false);

    const newUser: Ref<User> = ref(new User());

    const updateUser = (inputElement: HTMLInputElement) => {
      newUser.value = user;
      newUser.value.biography = inputElement.value;
      emit("update:user", newUser.value);
    };

    const fluctuate = (): void => {
      if (!isTransitionFinished.value) {
        isTransitionFinished.value = true;
      }
    };

    return {
      isTransitionFinished,
      updateUser,
      fluctuate
    };
  }
});
